/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
// libraries
import React, { useEffect, useState } from 'react';
import FlatList from 'flatlist-react';
import { MenuItem, Select, TextField } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { lightFormat } from 'date-fns';
import { Pagination } from '@material-ui/lab';

// js
import {
    Container,
    ContainerBox,
    ContainerMore,
    ContainerOptions,
    ContainerPaginator,
    InfoOption,
    LineSeparator,
    TitleBox,
    TitleOption,
} from './historicStyles';

// components
import ModalLoading from '../../components/ModalLoading';

// components (navigation)
import DrawerNavigation from '../../routes/DrawerNavigation/DrawerNavigation';

// types
import { ListHistories, ReverseCondition } from '../../services/histories';

// interfaces
const HistoricPage: React.FC = () => {
    // constants
    const token: any = String(localStorage.getItem('token') || '');

    // states
    const [allHistoric, setAllHistoric] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [qtdPages, setQtdPages] = useState(1);
    const [activeLoading, setActiveLoading] = useState(false);

    // api
    const GetListHistoric = async (pageList = page) => {
        setActiveLoading(true);
        const listHistoric: any = await ListHistories(search, pageList, token);
        if (listHistoric?.status === 200) {
            setAllHistoric(listHistoric.result.list);
            setQtdPages(listHistoric.result.qtdPages || 1);
        }
        setActiveLoading(false);
    };

    // methods
    const reverterCondition = async (id: string, type: string) => {
        setActiveLoading(true);
        const listHistoric: any = await ReverseCondition(id, type, token);
        setActiveLoading(false);
        if (listHistoric?.status === 200) {
            alert(listHistoric.message);
            GetListHistoric();
        }
    };

    const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        GetListHistoric(value);
    };

    function AdjustTypeItem(type: string) {
        if (type === 'user') {
            return 'Usuário';
        }
        if (type === 'category') {
            return 'Categoria';
        }
        return 'Módulo';
    }

    function AdjustTypes(action: string) {
        if (action === 'create') {
            return 'Criação';
        }
        if (action === 'edit') {
            return 'Edição';
        }
        if (action === 'update') {
            return 'Atualização';
        }
        if (action === 'delete') {
            return 'Exclusão';
        }
    }

    function AdjustNextTypes(action: string) {
        if (action === 'create') {
            return 'Exclusão';
        }
        if (action === 'edit') {
            return 'Edição';
        }
        if (action === 'update') {
            return 'Atualização';
        }
        if (action === 'delete') {
            return 'Criação';
        }
    }

    const SearchHistoric = (txt: any) => {
        const infoSearch = txt.target.value;
        setSearch(infoSearch);
    };

    // useEffect
    useEffect(() => {
        const timeOutId = setTimeout(() => {
            setPage(1);
            GetListHistoric(1);
        }, 500);
        return () => clearTimeout(timeOutId);
    }, [search]);

    // renders
    const RenderListItems = (item: any) => {
        const {
            name, currentMethod, type, dateCreated,
        } = item;

        const dateInt = Number(dateCreated);
        const date = new Date(dateInt);
        const formatDate = lightFormat(date, 'dd/MM/yyyy');
        const formatHour = lightFormat(date, 'HH:mm');
        const concatDate = `${formatDate} às ${formatHour}`;

        const handleChange = async (event: any) => {
            const { id } = event.target.value;
            const messageConfirm = type === 'category' && currentMethod === 'create'
                ? `Deseja reverter a criação de "${name}"? A categoria será excluída e os módulos vinculados ficarão sem categoria. Essa exclusão poderá ser revertida depois pelo Histórico.`
                : `Deseja reverter a ${AdjustTypes(currentMethod)?.toLowerCase()} de "${name}"?`;
            const confirmRestore = window.confirm(messageConfirm);
            if (confirmRestore) {
                reverterCondition(id, type);
            }
        };

        return (
            <>
                <ContainerOptions>
                    <InfoOption>{name}</InfoOption>
                    <InfoOption>
                        {AdjustTypeItem(type)}
                    </InfoOption>
                    <InfoOption>{AdjustTypes(currentMethod)}</InfoOption>
                    <InfoOption>{AdjustNextTypes(currentMethod)}</InfoOption>
                    <ContainerMore>
                        <InfoOption width="100%">{concatDate}</InfoOption>
                        <Select value="" onChange={handleChange}>
                            <MenuItem value={{ ...item }}>
                                Reverter modificação
                            </MenuItem>
                        </Select>
                    </ContainerMore>
                </ContainerOptions>
                <LineSeparator />
            </>
        );
    };

    const RenderHistoricPage = () => {
        if (!localStorage.getItem('existUser')) {
            return <Redirect to="/" />;
        }
        return (
            <Container>
                <ModalLoading activeLoading={activeLoading} />
                <DrawerNavigation />
                <ContainerBox>
                    <TextField
                        fullWidth
                        label="Buscar por nome do item modificado"
                        onChange={SearchHistoric}
                        value={search}
                    />
                    <TitleBox>Lista de histórico</TitleBox>
                    <ContainerOptions>
                        <TitleOption>Título/Nome</TitleOption>
                        <TitleOption>Tipo</TitleOption>
                        <TitleOption>Ação anterior</TitleOption>
                        <TitleOption>Ação posterior</TitleOption>
                        <TitleOption>Data da modificação</TitleOption>
                    </ContainerOptions>
                    <LineSeparator />
                    <FlatList list={allHistoric} renderItem={RenderListItems} />
                    <ContainerPaginator>
                        <Pagination
                            count={qtdPages}
                            page={page}
                            variant="outlined"
                            shape="rounded"
                            onChange={handleChangePage}
                            color="primary"
                        />
                    </ContainerPaginator>
                </ContainerBox>
            </Container>
        );
    };

    return RenderHistoricPage();
};

export default HistoricPage;
